export const DETACHED_SHARING_DATA_REQUEST = 'DETACHED_SHARING_DATA_REQUEST'
export function detachedSharingDataRequest() {
    return {
        type: DETACHED_SHARING_DATA_REQUEST
    }
}

export const DETACHED_SHARING_DATA_SUCCESS = 'DETACHED_SHARING_DATA_SUCCESS'
export function detachedSharingDataSuccess(detachedSharingData) {
    return {
        type: DETACHED_SHARING_DATA_SUCCESS,
        detachedSharingData
    }
}

export const SET_DETACHED_SHARING_DATA = 'SET_DETACHED_SHARING_DATA'
export function setDetachedSharingData(detachedSharingData) {
    return {
        type: SET_DETACHED_SHARING_DATA,
        detachedSharingData
    }
}

export const DETACHED_SHARING_DATA_ERROR = 'DETACHED_SHARING_DATA_ERROR'
export function detachedSharingDataError() {
    return {
        type: DETACHED_SHARING_DATA_ERROR
    }
}

export const START_DETACHED_SHARING_LOADING = 'START_DETACHED_SHARING_LOADING'
export function startDetachedSharingLoading() {
    return {
        type: START_DETACHED_SHARING_LOADING
    }
}

export const STOP_DETACHED_SHARING_LOADING = 'STOP_DETACHED_SHARING_LOADING'
export function stopDetachedSharingLoading() {
    return {
        type: STOP_DETACHED_SHARING_LOADING
    }
}

export const SHARED_USERS_REQUEST = 'SHARED_USERS_REQUEST'
export function sharedUsersRequest() {
    return {
        type: SHARED_USERS_REQUEST
    }
}

export const SHARED_USERS_SUCCESS = 'SHARED_USERS_SUCCESS'
export function sharedUsersSuccess(sharedUsers) {
    return {
        type: SHARED_USERS_SUCCESS,
        sharedUsers
    }
}

export const SHARED_USERS_ERROR = 'SHARED_USERS_ERROR'
export function sharedUsersError() {
    return {
        type: SHARED_USERS_ERROR
    }
}

export const SHARE_DETACHED_SHARING_DATA = 'SHARE_DETACHED_SHARING_DATA'
export function shareDetachedSharingData(postShareData) {
    return {
        type: SHARE_DETACHED_SHARING_DATA,
        postShareData
    }
}

export const SHARE_DETACHED_SHARING_DATA_SUCCESS = 'SHARE_DETACHED_SHARING_DATA_SUCCESS'
export function shareDetachedSharingDataSuccess() {
    return {
        type: SHARE_DETACHED_SHARING_DATA_SUCCESS
    }
}

export const SHARE_DETACHED_SHARING_DATA_ERROR = 'SHARE_DETACHED_SHARING_DATA_ERROR'
export function shareDetachedSharingDataError() {
    return {
        type: SHARE_DETACHED_SHARING_DATA_ERROR
    }
}
